/**
 * Session Store (Zustand)
 *
 * Manages global state for the active PDF processing session:
 * - Active session details
 * - Connection IDs (customer, practice, EMR)
 * - Session counters
 */

import { create } from 'zustand';
import type { SessionResponse } from '../types/api';

interface SessionStore {
  // Active session
  activeSession: SessionResponse | null;
  setActiveSession: (session: SessionResponse | null) => void;

  // Connection IDs
  customerId: string;
  practiceId: string;
  emrConnectionId: string;
  setConnectionIds: (customerId: string, practiceId: string, emrConnectionId: string) => void;

  // Update session counters (for real-time updates)
  updateSessionCounters: (counters: Partial<SessionResponse['counters']>) => void;

  // Clear session
  clearSession: () => void;
}

export const useSessionStore = create<SessionStore>((set) => ({
  activeSession: null,
  customerId: '',
  practiceId: '',
  emrConnectionId: '',

  setActiveSession: (session) => set({ activeSession: session }),

  setConnectionIds: (customerId, practiceId, emrConnectionId) =>
    set({ customerId, practiceId, emrConnectionId }),

  updateSessionCounters: (counters) =>
    set((state) => ({
      activeSession: state.activeSession
        ? {
            ...state.activeSession,
            counters: { ...state.activeSession.counters, ...counters },
          }
        : null,
    })),

  clearSession: () =>
    set({
      activeSession: null,
      customerId: '',
      practiceId: '',
      emrConnectionId: '',
    }),
}));
